import * as React from 'react';
import Title from 'src/components/common/Title';
import { Form, Row, Col, notification } from 'antd';
import StandardButton from 'src/components/common/StandardButton/StandardButton';
import { FormComponentProps } from 'antd/lib/form';
import { AuthContext } from 'src/components/context/AuthContext';
import { ConfirmPassword } from '../Form/ConfirmPassword/ConfirmPassword';

function RequestRecoveryCode(props: FormComponentProps & {
    onConfirmed: (newPassword: string) => void,
    user: any, pass: string
}) {

    const [newPass, setNewPass] = React.useState("");
    const authContext = React.useContext(AuthContext);

    const [loading, setLoading] = React.useState(false);

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();


        props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async (errs) => {
            if (!errs) {
                setLoading(true);

                try {
                    await authContext.completeNewPassword(props.user, newPass);
                    props.onConfirmed(newPass);
                } catch (error) {
                    console.error(error);
                    notification.error({
                        message: "Não possível alterar a senha.",
                        description: "Um erro ocorreu durante a tentiva de alteração de senha. Por favor tente novamente."
                    });
                    setLoading(false);
                }
            }
        });
    }

    return (
        <Form style={{ maxWidth: "664px", margin: "auto" }} onSubmit={(e) => handleSubmit(e)}>
            <Title size="h2">Crie uma nova senha</Title>

            <ConfirmPassword form={props.form} onChange={(e) => setNewPass(e.target.value)}
                label="Nova senha" placeholder="Digite a sua nova senha" />

            <Row className="actions-btn-row">
                <Col xs={24} sm={24} md={24} lg={24}>
                    <StandardButton block loading={loading} htmlType="submit" >
                        Entrar
                    </StandardButton>
                </Col>
            </Row>
        </Form>
    );
}

export default Form.create()(RequestRecoveryCode);



// WEBPACK FOOTER //
// ./src/components/common/ChangePasswordRequired/ChangePasswordRequired.tsx